import { DEFAULT_COLOR_PRIMARY, DEFAULT_COLOR_WHITE } from '../constants'
import { basePropertiesSchema } from '../base-schema-properties'
import { textWeightSchema } from '../common'
import { DEFAULT_FLOATING_BANNER_ITEM } from './constants'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Floating banner',
  description:
    'A floating banner containing one or more vertically stacked items',
  type: 'object',
  required: [
    'width',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'paddingLeft',
    'paddingRight',
    'paddingVertical',
    'itemsGap',
    'items',
  ],
  properties: {
    ...basePropertiesSchema,
    width: {
      title: 'Floating banner width, px',
      type: 'number',
      default: 320,
      minimum: 1,
    },
    backgroundColor: {
      title: 'Background color',
      type: 'string',
      default: DEFAULT_COLOR_PRIMARY,
    },
    borderColor: {
      title: 'Border color',
      type: 'string',
      default: DEFAULT_COLOR_WHITE,
    },
    borderWidth: {
      title: 'Border width, px',
      type: 'number',
      default: 2,
      minimum: 0,
    },
    borderRadius: {
      title: 'Border radius, px',
      type: 'number',
      default: 20,
      minimum: 0,
    },
    paddingLeft: {
      title: 'Left padding, px',
      type: 'number',
      default: 5,
      minimum: 0,
    },
    paddingRight: {
      title: 'Right padding, px',
      type: 'number',
      default: 5,
      minimum: 0,
    },
    paddingVertical: {
      title: 'Vertical padding, px',
      type: 'number',
      default: 5,
      minimum: 0,
    },
    itemsGap: {
      title: 'Gap between items, px',
      type: 'number',
      default: 8,
      minimum: 0,
    },
    items: {
      title: 'Banner items',
      type: 'array',
      'ui:options': {
        showIndexNumber: true,
      },
      items: {
        title: 'Banner item',
        type: 'object',
        required: [
          'textSize',
          'fontWeight',
          'textColor',
          'textPaddingLeft',
          'textPaddingRight',
          'leftImageMaxHeight',
          'rightImageMaxHeight',
          'hideWhenHasTicket',
          'hideWhenTicketsSelected',
          'targetType',
        ],
        properties: {
          text: {
            title: 'Text',
            type: 'string',
            default: DEFAULT_FLOATING_BANNER_ITEM.text,
            'ui:options': {
              emptyValue: '',
              placeholder: 'Get your ticket now!',
              type: 'textarea',
              rows: 3,
            },
          },
          textSize: {
            title: 'Text size, px',
            type: 'number',
            default: DEFAULT_FLOATING_BANNER_ITEM.textSize,
            minimum: 1,
          },
          fontWeight: {
            ...textWeightSchema,
            title: 'Text font weight',
            enum: textWeightSchema.enum.slice(1),
            enumNames: textWeightSchema.enumNames.slice(1),
            default: DEFAULT_FLOATING_BANNER_ITEM.fontWeight,
          },
          textColor: {
            title: 'Text color',
            type: 'string',
            default: DEFAULT_FLOATING_BANNER_ITEM.textColor,
          },
          textPaddingLeft: {
            title: 'Text left padding, px',
            type: 'number',
            default: DEFAULT_FLOATING_BANNER_ITEM.textPaddingLeft,
            minimum: 0,
          },
          textPaddingRight: {
            title: 'Text right padding, px',
            type: 'number',
            default: DEFAULT_FLOATING_BANNER_ITEM.textPaddingRight,
            minimum: 0,
          },
          leftImage: {
            title: 'Left image',
            type: 'string',
            default: DEFAULT_FLOATING_BANNER_ITEM.leftImage,
          },
          leftImageMaxHeight: {
            title: 'Left image max height, px',
            type: 'number',
            default: DEFAULT_FLOATING_BANNER_ITEM.leftImageMaxHeight,
            minimum: 1,
          },
          rightImage: {
            title: 'Right image',
            type: 'string',
            default: DEFAULT_FLOATING_BANNER_ITEM.rightImage,
          },
          rightImageMaxHeight: {
            title: 'Right image max height, px',
            type: 'number',
            default: DEFAULT_FLOATING_BANNER_ITEM.rightImageMaxHeight,
            minimum: 1,
          },
          hideWhenHasTicket: {
            title: 'Hide when the user already has a ticket',
            type: 'boolean',
            default: DEFAULT_FLOATING_BANNER_ITEM.hideWhenHasTicket,
          },
          hideWhenTicketsSelected: {
            title: 'Hide when tickets are added to the cart',
            type: 'boolean',
            default: DEFAULT_FLOATING_BANNER_ITEM.hideWhenTicketsSelected,
          },
          targetType: {
            title: 'Click action',
            type: 'string',
            enum: ['block', 'link', 'none'],
            enumNames: ['Go to page block', 'Open link', 'No action'],
            default: DEFAULT_FLOATING_BANNER_ITEM.targetType,
          },
          blockHash: {
            title: 'Target page block',
            description:
              'To make a block easier to find, first fill in its “In-page block id” field.',
            type: 'string',
            'ui:hidden': '{{parentFormData.targetType !== "block"}}',
          },
          link: {
            title: 'Link',
            type: 'string',
            'ui:hidden': '{{parentFormData.targetType !== "link"}}',
          },
        },
      },
    },
    tmp_stackNotice: {
      title: 'Using multiple blocks',
      description:
        'You can add multiple “Floating banner” blocks to the page. They will automatically be combined into a single vertical stack.',
      type: 'object',
      properties: {},
    },
  },
}
